import { useQuery } from 'react-query';

import { queryClient, request, useCurrentUserId } from '@/utils';

import { XPRecord } from '../types';

export const PAGE_SIZE = 100;

const XP_RECORD_URL = '/xp/records';

export const useXPRecordList = (start = 0) => {
  const userId = useCurrentUserId();

  const query = useQuery(
    [XP_RECORD_URL, userId, start],
    () => {
      return request.get<{
        records: XPRecord[];
        total_count: number;
      }>(XP_RECORD_URL, {
        start,
        limit: PAGE_SIZE,
      });
    },
    {},
  );

  return query;
};

export const invalidXPRecordList = (userId?: string) => {
  queryClient.invalidateQueries([XP_RECORD_URL, userId]);
};
